import { render, staticRenderFns } from "./PaywallLinks.vue?vue&type=template&id=2e45657f&"
import script from "./PaywallLinks.vue?vue&type=script&lang=ts&"
export * from "./PaywallLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports